module.exports = __webpack_public_path__ + "Legal_Header_new.c7685266.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Legal_Header_new.png
// module id = 7lm+
// module chunks = 0